import DeleteGenericModal from "../../modals/DeleteGenericModal";
import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useDeleteModal from "../../modals/useDeleteModal";
import axios from "axios";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import useEditModal from "../../modals/useEditModal";
import * as React from "react";
import UploadPdf from "../../components/UploadPdf";
import GenericModal2 from "../../modals/GenericModal2";

const PdfList = () => {

  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/pdf/list', []);

  const deleteElement = id => axios.delete(Apis.PROD + '/pdf/' + id)

  const {
    wrapper: wrapper1,
    openDeleteModal
  } = useDeleteModal({
    text: '¿Desea eliminar este pdf?',
    action: deleteElement,
    onRefresh: fetchData
  })

  const {wrapper: wrapper2, editAction} = useEditModal({
    editComponent: <UploadPdf />,
    onRefresh: fetchData
  });

  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        <Button size='xs' onClick={() => editAction({id:cell.row.original.id, codigo: cell.row.original.codigo})}>Subir pdf</Button>
        <Button size='xs' variant='danger' onClick={() => openDeleteModal(cell.row.original.id)}>Eliminar</Button>
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const columns = useMemo(
    () => [
      {
        header: 'Codigo',
        accessorKey: 'codigo',
      },
      {
        header: 'Titulo',
        accessorKey: 'titulo',
      },
      {
        header: 'Url',
        accessorKey: 'url',
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Pdfs'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            filterAdd={() => editAction()}
            noData='No existen pdfs registrados'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <DeleteGenericModal {...wrapper1} />
      <GenericModal2 {...wrapper2} />
    </PageContainerFull>
  )
}

export default PdfList
